// 录音中的波形动画, 移植自 ly-gpt 的 components/chat/voiceSvg.vue
export default function VoiceWave({ className = "" }: { className?: string }) {
  const COUNT = 9
  const RECT_WIDTH = 2
  const RECT_RADIUS = RECT_WIDTH / 2
  const RECT_HEIGHT_MIN = 4
  const RECT_HEIGHT_MAX = 16
  const DURATION = 0.8
  const SPACING = 2
  const SIZE = 20
  const width = COUNT * (SPACING + RECT_WIDTH)

  return (
    <svg
      className={className}
      width={width}
      height={SIZE}
      color="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      {Array.from({ length: COUNT }).map((_, index) => (
        <rect
          key={index}
          fill="currentColor"
          rx={RECT_RADIUS}
          ry={RECT_RADIUS}
          height={RECT_HEIGHT_MIN}
          width={RECT_WIDTH}
          x={index * (SPACING + RECT_WIDTH)}
          y={SIZE / 2 - RECT_HEIGHT_MIN / 2}
        >
          <animate
            attributeName="height"
            values={`${RECT_HEIGHT_MIN}; ${RECT_HEIGHT_MAX}; ${RECT_HEIGHT_MIN}`}
            keyTimes="0; 0.5; 1"
            dur={`${DURATION}s`}
            begin={`${(DURATION / COUNT) * index}s`}
            repeatCount="indefinite"
          />
          <animate
            attributeName="y"
            values={`${SIZE / 2 - RECT_HEIGHT_MIN / 2}; ${SIZE / 2 - RECT_HEIGHT_MAX / 2}; ${SIZE / 2 - RECT_HEIGHT_MIN / 2}`}
            keyTimes="0; 0.5; 1"
            dur={`${DURATION}s`}
            begin={`${(DURATION / COUNT) * index}s`}
            repeatCount="indefinite"
          />
        </rect>
      ))}
    </svg>
  )
}
